const DEFAULT_TIMEOUT_MS = 500;
const isNonEmptyString = (value) => typeof value === "string" && value.trim().length > 0;
const parseSessionId = (value) => {
    if (typeof value === "number" && Number.isInteger(value) && value >= 1) {
        return value;
    }
    if (typeof value === "string" && /^\d+$/.test(value)) {
        const parsed = Number(value);
        if (Number.isInteger(parsed) && parsed >= 1) {
            return parsed;
        }
    }
    return undefined;
};
const gtagGet = (measurementId, fieldName) => new Promise((resolve) => {
    try {
        window.gtag("get", measurementId, fieldName, resolve);
    }
    catch {
        resolve(undefined);
    }
});
/**
 * Resolve GA4 client_id and session_id via gtag("get", ...).
 * Returns undefined unless both identifiers are valid within the timeout.
 * Does not generate fallback identifiers.
 */
export const getGa4TrackingContext = async (measurementId, timeoutMs = DEFAULT_TIMEOUT_MS) => {
    if (!measurementId || typeof window === "undefined" || typeof window.gtag !== "function") {
        return undefined;
    }
    const timeout = new Promise((resolve) => {
        setTimeout(() => resolve(undefined), timeoutMs);
    });
    const lookup = Promise.all([
        gtagGet(measurementId, "client_id"),
        gtagGet(measurementId, "session_id"),
    ]).then(([clientIdRaw, sessionIdRaw]) => {
        const clientId = isNonEmptyString(clientIdRaw) ? clientIdRaw.trim() : undefined;
        const sessionId = parseSessionId(sessionIdRaw);
        if (!clientId || sessionId === undefined) {
            return undefined;
        }
        return { clientId, sessionId };
    });
    // TODO: Find optimal value for timeout?
    //       Timeout prevents GA4 callback waits from stalling business requests;
    //       lower values reduce UX delay but may drop metadata capture.
    return Promise.race([lookup, timeout]);
};
/**
 * Creates a request metadata extensions resolver that exposes GA4
 * context via flat extension keys.
 */
export const makeGa4RequestMetadataExtensionResolver = (measurementId) => {
    return async () => {
        const context = await getGa4TrackingContext(measurementId);
        if (!context) {
            return undefined;
        }
        return {
            ga4_client_id: context.clientId,
            ga4_session_id: String(context.sessionId),
        };
    };
};
